import {
  ExpiredSessionMessages,
  TranslationExpiredSessionMessages
} from "../interfaces/expiredSessionMessages";

export const messages: TranslationExpiredSessionMessages = {
  [ExpiredSessionMessages.formDialogTitle]: "Sua sessão expirou!",
  [ExpiredSessionMessages.formDialogContent]:
    "Realize novamente o login com seu usuário de acesso para continuar a utilizar o sistema com segurança",
  [ExpiredSessionMessages.formDialogActionText]: "Ir para página de login"
};
